import React, { useEffect } from 'react';
import 'react-table-6/react-table.css';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { Utils, Filters } from '../../../services';
import { ButtonGroup, Button } from 'reactstrap';
import { Ability, PageTitle, Table, TableButtons, CreateButton } from '../../../components';

import { loadWorkflows } from '../../../redux/modules/workflows';

import './WorkflowsList.css';

const WorkflowsList = () => {
    const { t }        = useTranslation();
    const dispatch     = useDispatch();
    const default_lang = Utils.default_lang();

    const { user }      = useSelector(state => state.auth);
    const { workflows } = useSelector(state => state.workflows);

    useEffect(() => {
        dispatch(loadWorkflows());
    }, [dispatch]);

    const title = <span>{t("workflows.workflow", {count: 42})}</span>;

    const actions = (
        <Ability can="workflows:create">
            <CreateButton module={`workflows`} text="workflows.add" />
        </Ability>
    );

    const columns = [{
        Header: t('workflows.name'),
        accessor: "name",
        filterMethod: Filters.textFilterMethod("name." + default_lang),
        Filter: Filters.textFilter,
        filterAll: true,
        Cell: row => row.value && (
            <div className="name_cell">
                <Link to={`/workflows/edit/${row.original.id}`}>
                    {row.original.name[default_lang]}
                </Link>
            </div>
        )
    }, {
        Header: t('common.actions'),
        accessor: "id",
        maxWidth: 110,
        filterable: false,
        Cell: row => (
            <>
                <ButtonGroup>
                    <Ability can="workflows:edit">
                        <Button tag={Link} to={`/workflows/edit/${row.value}`} color="info" title={t("common.edit")} size="sm">
                            <i className="fa fa-edit"></i>
                        </Button>
                    </Ability>
                    <Ability can="workflows:delete">
                        <Button tag={Link} to={`/workflows/delete/${row.value}`} color="danger" title={t("common.delete")} size="sm">
                            <i className="fa fa-trash"></i>
                        </Button>
                    </Ability>
                </ButtonGroup>
                <ButtonGroup>
                    <Ability can="workflows:start">
                        <Button
                            to={`/public/${user?.tkt_instance?.slug}/workflow/${row.value}`}
                            tag={Link}
                            size="sm"
                            color="warning"
                            title={t("workflows.start")}
                            target="_blank"
                            className="ml-2"
                        >
                            <i className="fa fa-play"></i>&nbsp;
                        </Button>
                    </Ability>
                </ButtonGroup>
            </>
        )
    }];

    return (
        <div className="WorkflowsList">
            <PageTitle icon="code-fork" title={title} actions={actions} />
            <Table id="workflowsTable" data={workflows} columns={columns} />
        </div>
    );
}

export default WorkflowsList;
